// Libraries
import { Flex } from '@chakra-ui/react';
// Components
import { ArrowIcon } from '@atoms/index';
//Types
import { ExpandCellProps } from './ExpandCell.types';

/**
 * ExpandCell component represents a cell used for expanding and collapsing rows in an expanded row table.
 *
 * @component
 * @param {Omit<ExpandedRow, 'toggleExpanded'>} props - ExpandCell props
 * @param {function} props.getIsExpanded - A function that returns a boolean indicating whether the row is expanded.
 * @param {function} props.getCanExpand - A function that returns a boolean indicating whether the row can be expanded.
 * @param {function} props.getToggleExpandedHandler - A function that returns a handler for toggling the expanded state of the row.
 * @returns {ReactElement} The rendered ExpandCell component.
 */
export const ExpandCell = ({ getIsExpanded, getCanExpand, getToggleExpandedHandler }: ExpandCellProps) => {
  const transform = getIsExpanded() ? 'rotate(90deg)' : 'rotate(0)';

  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      onClick={getToggleExpandedHandler()}
      cursor='pointer'
      className='my-box'
      role='group'
    >
      {getCanExpand() && (
        <ArrowIcon
          userSelect='none'
          _groupHover={{
            color: 'base',
          }}
          transform={transform}
          transition='all .3s ease-in'
        />
      )}
    </Flex>
  );
};
